/**
 * Erreurs normalisées.
 *
 * Une erreur porte un code stable, un message pour la personne, un statut HTTP
 * et, quand c'est utile, des détails. Le message suit la voix du produit
 * (2.2) : il dit ce qui s'est passé et ce qu'il faut faire.
 */
/** Catalogue des codes d'erreur et du statut HTTP qui leur correspond. */
export const CATALOGUE_ERREURS = {
    // Newsletter et réseaux (M9)
    'newsletter.campagne_immuable': { status: 409 },
    'newsletter.aucun_destinataire': { status: 409 },
    'registre_police.mentions_incompletes': { status: 422 },
    'registre_police.proposition_traitee': { status: 409 },
    'registre_police.sortie_existe': { status: 409 },
    'marketplace.idempotence_conflit': { status: 422 },
    // Requête et validation
    'validation.invalide': { status: 400 },
    'validation.champ_manquant': { status: 400 },
    'requete.malformee': { status: 400 },
    // Accès
    'auth.requise': { status: 401 },
    'auth.identifiants_invalides': { status: 401 },
    'auth.deux_facteurs_requis': { status: 401 },
    'auth.session_expiree': { status: 401 },
    'acces.refuse': { status: 403 },
    'acces.support_non_accorde': { status: 403 },
    // Ressources
    'ressource.introuvable': { status: 404 },
    'ressource.archivee': { status: 409 },
    // Œuvres
    'oeuvre.transition_interdite': { status: 409 },
    'oeuvre.raison_obligatoire': { status: 400 },
    'oeuvre.numero_inventaire_existe': { status: 409 },
    // Locations d'œuvres
    'location.etat_invalide': { status: 409 },
    'location.oeuvre_indisponible': { status: 409 },
    'location.ligne_inconnue': { status: 404 },
    'location.option_expiree': { status: 409 },
    'location.option_deja_levee': { status: 409 },
    'location.depot_excedentaire': { status: 409 },
    'location.periode_non_due': { status: 409 },
    'location.periode_deja_facturee': { status: 409 },
    // Ventes et fiscalité
    'facture.immuable': { status: 409 },
    'facture.numero_deja_attribue': { status: 409 },
    'facture.aucune_ligne': { status: 400 },
    /** Le calcul du document (Factur-X, PDF) refuse la pièce : rien n'est émis. */
    'facture.document_refuse': { status: 422 },
    'tva.regime_inconnu': { status: 400 },
    'tva.prix_achat_requis': { status: 400 },
    'tva.marge_negative': { status: 400 },
    // Comptabilité de la vue d'aigle
    /** Une version de la grille de répartition dont les parts ne tiennent pas. */
    'comptabilite.repartition_invalide': { status: 422 },
    // Numérotation
    'sequence.motif_invalide': { status: 400 },
    'sequence.numero_illisible': { status: 400 },
    // Coffre
    'coffre.confidentiel': { status: 403 },
    'coffre.document_verrouille': { status: 409 },
    // Site et viewing rooms
    'site.publication_en_cours': { status: 409 },
    'viewing_room.expiree': { status: 410 },
    'viewing_room.mot_de_passe_invalide': { status: 401 },
    'domaine.deja_utilise': { status: 409 },
    // Paliers et quotas
    'module.indisponible': { status: 403 },
    'quota.stockage_atteint': { status: 409 },
    'quota.utilisateurs_atteint': { status: 409 },
    // Connecteurs externes (M0)
    'connecteur.non_configure': { status: 409 },
    'connecteur.echec': { status: 502 },
    // Diffusion Artsy et Artnet (M10)
    'diffusion.flux_existe': { status: 409 },
    // RGPD
    'rgpd.suppression_impossible': { status: 409 },
    // Divers
    'boutique.fermee': { status: 409 },
    'boutique.oeuvre_indisponible': { status: 409 },
    'paiement.signature_invalide': { status: 400 },
    'conflit.version': { status: 409 },
    // Apps mobiles : version sous la minimale de sa plateforme (`versions-apps.ts`).
    'app.mise_a_jour_requise': { status: 426 },
    trop_de_requetes: { status: 429 },
    'interne.inattendue': { status: 500 },
};
/** La liste des codes, utile aux tests de contrat et à l'i18n. */
export const CODES_ERREUR = Object.keys(CATALOGUE_ERREURS);
/** Erreur applicative normalisée. */
export class AppError extends Error {
    code;
    status;
    details;
    constructor(code, message, details) {
        super(message);
        this.name = 'AppError';
        this.code = code;
        this.status = CATALOGUE_ERREURS[code].status;
        if (details !== undefined) {
            this.details = details;
        }
    }
    /** Forme JSON renvoyée par l'API. */
    toJSON() {
        return this.details === undefined
            ? { code: this.code, message: this.message, status: this.status }
            : { code: this.code, message: this.message, status: this.status, details: this.details };
    }
}
/** Reconnaît une erreur applicative. */
export function estAppError(valeur) {
    return valeur instanceof AppError;
}
/** Statut HTTP associé à un code. */
export function statutDuCode(code) {
    return CATALOGUE_ERREURS[code].status;
}
//# sourceMappingURL=errors.js.map